module.exports = __webpack_public_path__ + "static/fabrication-458d56f6a2c88bc6b1a6bfabc5acdd6a.jpg";